import React from 'react';
import {connect} from 'react-redux';
import {compose} from '../../utils'
import {bindActionCreators} from "redux";
import {setStep} from "../../actions";

const Step2 = (props) => {
    return (
        <div className="modal-content product-request__wrapper modalType2-step modalType2-step1 active">
            <p className="title">Спасибо за доверие!<br />Ваш заказ № {props.orderId} оформлен</p>
            <p className="modalType2-stepContant">Ваша покупка может быть оформлена ещё быстрее - нажмите "ПОДТВЕРДИТЬ
                ЗАКАЗ" под этой надписью, затем ввведите код из полученного SMS-сообщения в соответствующее поле,
                которое появится на экране. Наши операторы не побеспокоят Вас звонком, а сразу отправят заказ на сборку
                и доставку.
            </p>
            <a className="modalType2__redBtn fast_order_step2" onClick={e => props.setStep(3)}>Подтвердить заказ</a>
        </div>
    );
};

const mapStateToProps = ({orderId}) => {
    return {orderId};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setStep,
    }, dispatch);
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(Step2);
